import CacheableJson from '../../../../core/collections/CacheableJson';

class ZendeskFAQs extends CacheableJson {
	get url() {
		return 'nrl/zendesk-faq.json';
	}

	get faqsItems() {
		const items = this.toJSON()[0];

		return items.sections ? items.sections.map(section => {
			return {
				name: section.name,
				articles: items.articles.filter(article =>
					article.zendesk_section_id === section.zendesk_section_id
				),
			}
		}) : [];
	}
}

export default ZendeskFAQs;